export default __webpack_public_path__ + "static/media/image2vector.1db8c1f1.svg";